import { Component } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';

import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { BaseFormComponent, FormManagerService } from '@sim/form';

import { Collection, CollectionMeta } from '../../models/collection';
import { CollectionApiService } from '../../services/collection-api.service';

@Component({
  selector: 'app-collection-manager',
  styleUrls: ['./collection-manager.component.scss'],
  templateUrl: './collection-manager.component.html',
})
export class CollectionManagerComponent extends BaseFormComponent<Collection> {

  constructor(
    private readonly collectionApi: CollectionApiService,
    protected readonly formManager: FormManagerService,
    protected readonly route: ActivatedRoute,
    protected readonly router: Router,
    protected readonly snackBarService: MatSnackBar,
    protected readonly spinner: NgxSpinnerService,
    protected readonly translate: TranslateService,
  ) {
    super(
      snackBarService,
      translate,
      route,
      formManager,
      spinner,
      undefined,
      CollectionMeta,
      (id) => collectionApi.get(id as string).pipe(
        catchError(() => {
          this.snackBarService.open(this.translate.instant('Collezione non trovata'), undefined, { duration: 3000 });
          this.router.navigate(['/collections']);
          return EMPTY;
        })
      ),
      '/collections',
      router,
    );
  }

  addConcrete(collection: Collection) {
    return this.collectionApi.post(collection);
  }

  removeConcrete(collection: Collection) {
    if (collection.id) {
      return this.collectionApi.remove(collection.id);
    }
    return EMPTY;
  }

  editConcrete(collection: Collection) {
    return this.collectionApi.put(collection);
  }

  resetFormConcrete() {
    return EMPTY;
  }

}
